// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_tabContainer__verbas__cqavA {
  width: 100%;
  display: flex;
  justify-content: center;
}

.styles_title__verbas__7aw0e {
  align-items: center;
  color: #18316e;
  display: flex;
  flex: 1 1;
  font-family: "Abhaya Libre";
  font-size: 2rem;
  font-weight: 600;
  gap: 15px;
}

.styles_header__verbas__B8YGs {
  /* width: 100%; */
  display: flex;
  align-items: flex-end;
  /* padding: 1rem; */
}


`, "",{"version":3,"sources":["webpack://./src/pages/PreviaINSS/ModalAnalisar/StepsAnalisar/VerbasEsocial/styles.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,SAAO;EACP,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB","sourcesContent":[".tabContainer__verbas {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.title__verbas {\n  align-items: center;\n  color: #18316e;\n  display: flex;\n  flex: 1;\n  font-family: \"Abhaya Libre\";\n  font-size: 2rem;\n  font-weight: 600;\n  gap: 15px;\n}\n\n.header__verbas {\n  /* width: 100%; */\n  display: flex;\n  align-items: flex-end;\n  /* padding: 1rem; */\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabContainer__verbas": `styles_tabContainer__verbas__cqavA`,
	"title__verbas": `styles_title__verbas__7aw0e`,
	"header__verbas": `styles_header__verbas__B8YGs`
};
export default ___CSS_LOADER_EXPORT___;
